import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=1b817b70&scoped=true&"
import script from "./Circles.vue?vue&type=script&lang=js&"
export * from "./Circles.vue?vue&type=script&lang=js&"
import style0 from "./Circles.vue?vue&type=style&index=0&id=1b817b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b817b70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VSpacer})
